/* eslint-disable promise/prefer-await-to-then */
import _ from 'underscore';

export default props => {
    const { panelName } = props;
    const ctrl = props.ctrlFactory(panelName);

    const self = {
        ctrl,
        panelName,
        props,
        topPosition: 0,
        doScrollToElement: false,
        rollback() {
            return props.rollbackHandler(self);
        },
        commit(handlerParams) {
            return props.commitHandler(self, handlerParams);
        },
        confirm() {
            props.panelDispatcher.lockPanel(panelName);
            return (self.validationHandler || ctrl.validate)()
                .catch(error => {
                    props.panelDispatcher.setValidationResults(panelName, error);
                    self.markAsIncomplete();
                    self.openPanel();
                    return Promise.reject(error);
                })
                .then(() => {
                    return self
                        .clean()
                        .then(self.commit)
                        .then(result => {
                            self.closeAndMarkCompleted();
                            return result;
                        });
                })
                .finally(() => {
                    props.panelDispatcher.unlockPanel(panelName);
                    if (_.isFunction(self.ctrl.getState) && self.ctrl.getState().needApprove) {
                        self.openPanel();
                        self.ctrl.setState({ needApprove: false });
                    }
                });
        },
        async validate() {
            await (self.validationHandler || ctrl.validate)();
        },
        cancel() {
            return Promise.resolve(self.rollback())
                .then(self.confirm)
                .then(() => self.togglePanel(true));
        },
        notifyPanelStatusChanged() {
            if (props.onPanelStatusChanged) {
                props.onPanelStatusChanged();
            }
        },
        notifyPanelClosed(state) {
            if (props.onPanelClosed) {
                props.onPanelClosed(state);
            }
        },
        isComplete() {
            return self.getPanelInfo().status === 'complete';
        },
        closeAndMarkCompleted() {
            const isPreviousStatusTheSame = self.getPanelInfo().status === 'complete';
            props.panelDispatcher.markAsCompletedAndClose(panelName);
            if (!isPreviousStatusTheSame) {
                self.notifyPanelStatusChanged();
            }
            self.notifyPanelClosed(true);
        },
        markAsIncomplete() {
            const isPreviousStatusTheSame = self.getPanelInfo().status === 'incomplete';
            props.panelDispatcher.markAsIncomplete(panelName);
            if (!isPreviousStatusTheSame) {
                self.notifyPanelStatusChanged();
            }
        },
        togglePanel(closed) {
            props.panelDispatcher.togglePanel(panelName, closed);
            self.notifyPanelClosed(closed);
        },
        openPanel() {
            props.panelDispatcher.openPanel(panelName);
            self.notifyPanelClosed(true);
        },
        getPanelInfo() {
            return props.panelDispatcher.getPanelInfo(panelName);
        },
        clean() {
            return Promise.resolve(ctrl.clean && ctrl.clean()).then(() =>
                props.panelDispatcher.setValidationResults(panelName, undefined),
            );
        },
        setPanelPosition(topPosition) {
            self.topPosition = topPosition;
            if (self.doScrollToElement) {
                self.doScrollToElement = false;
                window.scrollTo(0, self.topPosition);
            }
        },
        scrollToElement() {
            self.doScrollToElement = true;
        },
        initPanelDomNode(domNode) {
            self.domNode = domNode;
        },
        setValidationHandler(fn) {
            self.validationHandler = fn;
        },
        updateTopPosition() {
            if (self.domNode) {
                self.setPanelPosition(window.pageYOffset + self.domNode.getBoundingClientRect().top);
            }
        },
        scrollToPanel() {
            setTimeout(() => {
                self.updateTopPosition();
                if (self.domNode) {
                    window.scrollTo(0, self.topPosition);
                }
            }, 300);
        },
    };

    ctrl.publisher.subscribe(() => {
        if (ctrl.isChanged ? ctrl.isChanged() : true) {
            self.markAsIncomplete();
        }
    });

    return self;
};
